
import RouterService from '@/service/RouterService'
import { Component, Vue } from 'vue-property-decorator'
import RacingService from '@/biz/service/Racing/RacingService'

@Component
export default class RacingIndex extends Vue {
  private Service = RacingService

  private handleEntra (v: { id: string; title: string; racing_type: string; racing_level: number }) {
    // 年赛：先进入子赛事列表（周赛/月赛），再进入才是详情
    if (Number(v.racing_level) === 3) {
      RouterService.push('/racing-manage/children', { racing_id: v.id, title: v.title })
      return
    }
    RouterService.push('/racing/info', { racing_id: v.id, id: v.id })
  }
}
